module.exports = __webpack_public_path__ + "static/media/md-more.9c0bd802.svg";